import { ShopifyStoreProduct, VenueListShopifyStoreProductsFilter } from '../../graphql/API';
import { venueListShopifyStoreProducts } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const venueListShopifyStoreProductsApi = async (
  filter: VenueListShopifyStoreProductsFilter,
): Promise<ShopifyStoreProduct[]> => {
  const result = await executeGql(venueListShopifyStoreProducts, { filter });
  return processGqlResult('venueListShopifyStoreProducts.items', result);
};
